<template>
  <div class="basic_text_rich_type my_basic_text_rich_type" @mouseenter="module_isHover(true)"
       @mouseleave="module_isHover(false)">
    <div class="tooptipPart">
      <template v-if="$store.state.app.view_pattern === 'pc' && this.module.widgets_id !== this.editID"
                class="module_edit_btn">
        <my_edit_btn :module="module" :title="$t('widgets_basic_rich_text_index_2813')" @click.native="clickTime"></my_edit_btn>
        <my_edit_btn :module="module" tabName="animation" :title="$t('widgets_basic_article_classification_edit_330')"></my_edit_btn>
        <my_link_btn :module="module" :title="$t('components_my_link_index_2361')"></my_link_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index" :title="$t('widgets_basic_text_index_2865')"></my_close_btn>
      </template>
    </div>
    <div class="mask_text" v-show="showEdit" @click="changePop"></div>
    <div
    v-if="showEdit"
      class="editor"
      :style="{
        height: showEdit ? 'auto' : 0,
        overflow: 'hidden',
        position: 'relative',
        zIndex: 1
      }"
    >
      <div class="editorContent">
        <my_text_rich class="editorContent" height='30' :id="'editor' + module.widgets_id"
                      :content.sync="module.data.listArr.title" @on-content-change="onContentChange"></my_text_rich>
      </div>
    </div>
    <div class="coverPart module_text_font_size_frame" v-show="!showEdit">
      <div class="contentPart" @dblclick="clickTime">
        <set_link class="linkPart" :sendData="module.data.listArr.link" v-if="module.widgets_id !== editID"></set_link>
        <div
          class="editDiv"
          :id="'editDiv' + module.widgets_id"
          @mousedown.stop
          @focus="isLocked = true"
          @blur="isLocked = false"
          @input="changeText"
          v-html="content"
          :style="{
            lineHeight: module.data.pc_widgets_infor.lineHeight === $t('view_back_top_edit_103') ? 1.5 : (module.data.pc_widgets_infor.lineHeight + 'px'),
            fontSize: 'unset',
            minHeight: '30px'
          }"
        ></div>
        <!-- <my_div_edit
          class="textEdit"
          :value.sync="module.data.listArr.title"
          :module='this.module'
          @input="saveWrods"
          :style="{
            lineHeight: module.data.pc_widgets_infor.lineHeight === '默认'?'' : module.data.pc_widgets_infor.lineHeight + 'px',
            fontSize: module.data.pc_widgets_infor.fontSize + 'px',
            fontFamily: module.data.pc_widgets_infor.fontFamily,
            textAlign: module.data.pc_widgets_infor.textAlign,
            fontWeight: module.data.pc_widgets_infor.fsWeight,
            fontStyle: module.data.pc_widgets_infor.fsItalics,
            textDecoration: module.data.pc_widgets_infor.fontUnderline,
            webkitBackgroundClip: 'text',
            webkitTextFillColor: module.data.pc_widgets_infor.pattern == 'linear_gradient' ? 'transparent' : '',
            color: module.data.pc_widgets_infor.pattern == 'pure_color' ? module.data.pc_widgets_infor.titleColor : '',
            backgroundImage:
              module.data.pc_widgets_infor.pattern == 'linear_gradient'
                ? 'linear-gradient(' +
                  module.data.pc_widgets_infor.linear_gradient.deg +
                  'deg,' +
                  module.data.pc_widgets_infor.linear_gradient.start_color +
                  module.data.pc_widgets_infor.linear_gradient.start_pointer +
                  '%,' +
                  module.data.pc_widgets_infor.linear_gradient.end_color +
                  module.data.pc_widgets_infor.linear_gradient.end_pointer +
                  '%)'
                : ''
          }"
        ></my_div_edit> -->
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'basic_text_rich_type',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isHover: false,
      timer: null,
      isLocked: false,
      showEdit: false,
      content: ''
    };
  },
  computed: {
    editID() {
      if (this.$store.state.app.module_Data) {
        return this.$store.state.app.module_Data.widgets_id;
      } else {
        return 0;
      }
    },
    listArr() {
      return this.module.data.listArr
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    }
  },
  watch: {
    '$store.state.main_dialog.main_dialog_isShow'(val) {
      if (val === false) {
        this.showEdit = false;
      } else {
        if (this.$store.state.app.module_Data !== null && this.module.widgets_id == this.$store.state.app.module_Data.widgets_id) {
          this.showEdit = true
        }
      }
    },
    showEdit(val) {
      if (!val) {
        console.log('this.content:', this.content)
        this.module.data.listArr.title = (this.content || '').replace(/font-family:\s*?(.*?);;/g, (str) => {
          return (str || '').replaceAll('&quot;', '')
        })
      }
    },
    'module.data.pc_widgets_infor': {
      handler: function (val) {
        this.$nextTick(() => {
          let heightValue = $(`#u${this.module.widgets_id} .ke-edit-iframe`)
            .contents()
            .find('body')
            .height();
            if(this.module.data.pc_widgets_infor.lineHeight == i18n.t('view_back_top_edit_103') && heightValue == 43) {
              heightValue = 33
            }
            // console.log('heightValue2:',heightValue)
          $('.ed_container').css('height', heightValue);
          $('.ke-edit-iframe').css('height', heightValue);
          $('.ke-edit').css('height', heightValue);
        });
      },
      deep: true
    },
    // 修改文字颜色
    'module.data.pc_widgets_infor.titleColor': {
      handler: function (val) {
        this.changeColor(val);
      },
      deep: true
    },
    //修改文字大小
    'module.data.pc_widgets_infor.fontSize': {
      handler: function (val) {
        this.changeFontSize(val);
      },
      deep: true
    },
    //修改文字字体
    'module.data.pc_widgets_infor.fontFamily': {
      handler: function (val) {
        this.changeFontFamily(val);
      },
      deep: true
    },
    'pc_widgets_infor.customFont.name'() {
      this.changeFontFamily();
    },
    //修改文字对齐
    'module.data.pc_widgets_infor.textAlign': {
      handler: function (val) {
        this.changeTextAlign(val);
      },
      deep: true
    },
    //修改文字行高
    'module.data.pc_widgets_infor.lineHeight': {
      handler: function (val) {
        this.changeLineHeight(val);
      },
      deep: true
    },
    isLocked(val) {
      let htmlWord = $(`#u${this.module.widgets_id} .editDiv`).html();
      if (htmlWord === i18n.t('components_my_div_edit_index_2302') || this.module.data.listArr.title === i18n.t('components_my_div_edit_index_2302')) {
        this.module.data.listArr.title = '';
      } else if (!htmlWord && !val) {
        this.module.data.listArr.title = i18n.t('components_my_div_edit_index_2302');
      } else {
        this.module.data.listArr.title = htmlWord;
      }
      if (val) {
        $('#u' + this.module.widgets_id)
          .find('.contentPart')
          .addClass('focusDiv');
        var range = document.createRange();
        range.selectNodeContents(document.getElementById('editDiv' + this.module.widgets_id));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      } else if (!val) {
        window.getSelection().removeAllRanges();
        $('#u' + this.module.widgets_id)
          .find('.contentPart')
          .removeClass('focusDiv');
        // this.templet.dialog_close()
      }
    },
    'module.data.listArr.title'(val) {
      if (val === '') {
        this.module.data.listArr.title = i18n.t('components_my_div_edit_index_2302');
        this.content = this.module.data.listArr.title
      }
    }
  },
  methods: {
    changePop() {
      // this.templet.dialog_close();

      $(`#u${this.module.widgets_id} .ke-edit-iframe`)[0]
        .contentWindow.getSelection()
        .empty();
      $(`#u${this.module.widgets_id} .ke-edit-iframe`)[0].contentWindow.focus();
    },
    changeColor(val, oldval) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let _KindEditor = this.selectEditor();
        if (_KindEditor.cmd.range.collapsed) {
          _KindEditor.cmd.selectall();
        }
        _KindEditor.exec('forecolor', val);
       }, 300);
    },
    changeFontSize(val) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let _KindEditor = this.selectEditor();
        if (_KindEditor.cmd.range.collapsed) {
          _KindEditor.cmd.selectall();
        }
        _KindEditor.exec('fontsize', val + 'px');
      }, 300);
    },
    changeFontFamily(val) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let _KindEditor = this.selectEditor();
        if (_KindEditor.cmd.range.collapsed) {
          _KindEditor.cmd.selectall();
        }

        this.insertStyleToIframe()
        let fontFamily = (this.pc_widgets_infor.customFont && this.pc_widgets_infor.customFont.name) || this.pc_widgets_infor.fontFamily
        _KindEditor.exec('fontfamily', fontFamily);
      }, 300);
    },
    changeTextAlign(val) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let _KindEditor = this.selectEditor();
        if (_KindEditor.cmd.range.collapsed) {
          _KindEditor.cmd.selectall();
        }
        if (val == 'left') {
          _KindEditor.exec('justifyleft');
        } else if (val == 'center') {
          _KindEditor.exec('justifycenter');
        } else if (val == 'right') {
          _KindEditor.exec('justifyright');
        } else if (val == 'justify') {
          _KindEditor.exec('justifyfull');
        }
      }, 300);
    },
    changeLineHeight(val) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let _KindEditor = this.selectEditor();
        if (_KindEditor && _KindEditor.cmd.range.collapsed) {
          _KindEditor.cmd.selectall();
        }
        $(`#u${this.module.widgets_id} .ke-edit-iframe`)
          .contents()
          .find('body')
          .css('line-height', val + 'px');
        }, 300);
    },
    clickTag() {
    },
    selectEditor() {
      let index = 0;
      KindEditor.instances.map((e, i) => {
        if (e.srcElement[0].id === 'editor' + this.module.widgets_id) {
          index = i;
        }
      });
      return KindEditor.instances[index];
    },
    onContentChange(content) {
      this.$nextTick(() => {
        let myContent = $(`#u${this.module.widgets_id} .ke-edit-iframe`).contents().find('body').html();
        this.content = myContent;
      });
    },
    changeText(val) {
      let htmlWord = $(`#u${this.module.widgets_id} .editDiv`).html();
    },
    addActiveClass() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let id;
        if (this.module.widgets_id) {
          id = this.module.widgets_id;
          let _that = this;
          if ($(`#u${id} .ke-selected[data-name='bold']`).length == 1) {
            // $('.icon.bold').addClass('active')
            _that.$store.commit('font_style/SET_bold', true);
          } else {
            _that.$store.commit('font_style/SET_bold', false);
          }
          if ($(`#u${id} .ke-selected[data-name='underline']`).length == 1) {
            _that.$store.commit('font_style/SET_underline', true);
          } else {
            _that.$store.commit('font_style/SET_underline', false);
          }
          if ($(`#u${id} .ke-selected[data-name='italic']`).length == 1) {
            _that.$store.commit('font_style/SET_italics', true);
          } else {
            _that.$store.commit('font_style/SET_italics', false);
          }
        }
      }, 300);
    },
    clickTime() {
      if (this.$store.state.app.view_pattern !== 'pc') {
        return false;
      }
      this.showEdit = true;
      let _that = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(()=> {
        let _KindEditor = this.selectEditor();
        console.log('_KindEditor:',_KindEditor)
        _KindEditor.focus();
        if (_KindEditor.cmd.range.collapsed) {
          _KindEditor.cmd.selectall();
        }

        this.insertStyleToIframe()

        let lineHeight = `${this.module.data.pc_widgets_infor.lineHeight}px`
        if(this.module.data.pc_widgets_infor.lineHeight == i18n.t('view_back_top_edit_103')) {
          lineHeight = 1.5
        }

        $(`#u${this.module.widgets_id} .ke-edit-iframe`)
          .contents()
          .find('body')
          .css({padding: '0px', 'line-height': lineHeight, 'font-size': `${this.pc_widgets_infor.fontSize}px`, color:this.pc_widgets_infor.titleColor });
        $(`#u${this.module.widgets_id} .ke-edit-iframe`)
          .contents()
          .find('p')
          .css('margin', '0px');


          let heightValue = $(`#u${this.module.widgets_id} .ke-edit-iframe`)
            .contents()
            .find('body')
            .height()
            if(this.module.data.pc_widgets_infor.lineHeight == i18n.t('view_back_top_edit_103') && heightValue == 43) {
              heightValue = 33
            }
        // console.log('heightValue:',heightValue)
        _KindEditor.edit.setHeight(heightValue);
          $('.ed_container').css('height', heightValue)
          $('.ke-edit-iframe').css('height', heightValue)
          $('.ke-edit').css('height', heightValue)

        $(`#u${this.module.widgets_id} .ke-edit-iframe`)[0].contentDocument.onclick = function () {
          _that.addActiveClass();
        };
        this.$nextTick(() => {
          _that.addActiveClass();
        });
      },300)
    },
    module_isHover(val) {
      this.isHover = val;
    },
    saveWrods(data) {
      this.module.data.listArr.title = data;
    },
    insertStyleToIframe() {
      this.$nextTick(()=> {
        let customFont = this.pc_widgets_infor.customFont
        let $head = $(`#u${this.module.widgets_id} .ke-edit-iframe`).contents().find('head')
        let styleSelector = `#${customFont.name}`
        if (customFont.name && $head.find(styleSelector).length == 0) {
          $head.append($(styleSelector).clone())
          let fontStrList = this.getRichTextFontList()
          fontStrList.forEach((fontName) => {
            $head.append($('#' + fontName).clone())
          })
        }
      })
    },
    getRichTextFontList() {
      let fontStrList = (this.module.data.listArr.title || '').match(/font-family:\s*fontface?(.*?);/g) || []
      fontStrList = fontStrList.map(item => {
        item = item.replace('font-family:', '')
        item = item.replace(';', '')
        item = item.trim()
        return item
      })
      return fontStrList
    }
  },
  created() {
    if (this.module.data.listArr.title === '') this.module.data.listArr.title = i18n.t('components_my_div_edit_index_2302');
    this.module.data.listArr.title = (this.module.data.listArr.title || '').replace(/font-family:\s*?(.*?);;/g, (str) => {
      return (str || '').replaceAll('&quot;', '')
    })
    this.content = this.module.data.listArr.title
    if (this.module.data.pc_widgets_infor.customFont === undefined || Array.isArray(this.module.data.pc_widgets_infor.customFont)) {
      // 有一些开发时生成的历史错误数据 是数组，只有我自己的账号有 也顺手处理一下吧
      this.$set(this.module.data.pc_widgets_infor, 'customFont', {})
    }
    if (!this.module.data.pc_widgets_infor.fontList) {
      this.$set(this.module.data.pc_widgets_infor, 'fontList', [])
    }
    let fontStrList = this.getRichTextFontList()

    let fontList = this.module.data.pc_widgets_infor.fontList.filter(item => {
      return fontStrList.includes(item.name)
    })
    if (this.module.data.pc_widgets_infor.customFont && this.module.data.pc_widgets_infor.customFont.name) {
      fontList.push(this.module.data.pc_widgets_infor.customFont)
    }
    if (fontList.length) {
      this.$utils.insertStyle(fontList)
    }
  },
  mounted() {
    // let editor = KindEditor.create('#editor' + this.module.widgets_id,{
    //   filterMode : true,
    //   langType : "zh-CN",
    //   afterFocus : function() {
    //     alert("Focus!!!");
    //   }
    // });
    // debugger
    // KindEditor.create('#editor' +  this.module.widgets_id,
    // {
    //   afterFocus : function() {
    //     alert("Focus!!!");
    //   }
    // });
    // $('#u'+this.module.widgets_id +' .edit-div').focus()
    // $('#u'+this.module.widgets_id +' .edit-div').click()
    // this.changeColor(this.module.data.pc_widgets_infor.titleColor)
    // this.changeFontSize(this.module.data.pc_widgets_infor.fontSize);
    // this.changeFontFamily(this.module.data.pc_widgets_infor.fontFamily)
    // this.changeTextAlign(this.module.data.pc_widgets_infor.textAlign);
    // this.changeLineHeight(this.module.data.pc_widgets_infor.lineHeight);
    let heightValue = $(`#u${this.module.widgets_id} .coverPart`).height();
    // $('.ed_container').css('height',heightValue)
    // $('.ke-edit-iframe').css('height',heightValue)
    // $('.ke-edit').css('height',heightValue)
    $(`#u${this.module.widgets_id} .ke-edit-iframe`)
      .contents()
      .find('body').css({'padding': '0px', 'line-height': this.module.data.pc_widgets_infor.lineHeight + 'px'});
    // let heightValue = $('.coverPart').height()
    // $('.ed_container').css('height',heightValue)
    // $('.ke-edit-iframe').css('height',heightValue)
    // $('.ke-edit').css('height',heightValue)
    // // $('.ed_container').hide()
    // $(`#u${this.module.widgets_id} .ke-edit-iframe`)
    //   .contents()
    //   .find('body').css({'padding':'0px','line-height':this.module.data.pc_widgets_infor.lineHeight + 'px'});
    // let _KindEditor = this.selectEditor();
    // _KindEditor.edit.setHeight(1000)
  }
};
</script>

<style lang="scss" scoped>
.mb_pattern .basic_text_rich_type {
  cursor: text;

  .contentPart {
    cursor: text;
  }
}

.basic_text_rich_type:hover {
  .tooptipPart {
    display: block;
  }
}

.basic_text_rich_type {
  .tooptipPart {
    right: 0;
    top: 0px;
    display: none;
  }

  .tooptipPart:hover {
    display: block;
  }
}

.basic_text_rich_type {
  .textEdit {
    display: block;
    width: 100%;
    cursor: text;
    min-width: 10px;
    overflow: hidden;
    pointer-events: none;
  }
}

.contentPart.focusDiv {
  border: 1px dashed #5874d8;
  cursor: text;
}

.contentPart {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: move;

  .linkPart {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .linkPart.noClick {
    pointer-events: none;

    /deep/ .cover_anchor {
      pointer-events: none;
    }
  }
}

.coverPart {
  height: 100%;
}

.my_basic_text_rich_type {
  height: 100%;
}

.my_basic_text_rich_type .ed_container /deep/ .ke-container,
.my_basic_text_rich_type .ed_container {
  width: 100% !important;
  border: none;
}

.my_basic_text_rich_type .ed_container /deep/ .tips {
  display: none;
}

.my_basic_text_rich_type .ed_container /deep/ .ke-container .ke-toolbar {
  display: none !important;
}

.my_basic_text_rich_type .ed_container /deep/ .ke-content {
  padding: 0;
}

.mask_text {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_text_rich_type/index.vue